:root {
  --cta-link-transform: rotate(0deg);
  --cta-link-mb: @anchor-spacing; //mb -> margin bottom
  --cta-link-text-margin: 0 0 0 5px;
  --cta-link-color: @ig-grey-900;
}

@cta-primary-color: #67c058;
@cta-primary-hover-color: #369136;

a {
  text-decoration: none;
}

h3 {
  display: inline-block;
  color: @ig-grey-900;
  font-size: 22px;
  line-height: 30px;
  .MatterMedium();
  margin-bottom: 5px;
}

.cta-wrapper.primary,
.cta-wrapper.secondary,
.cta-wrapper.secondary--dark {
  height: 45px;
  width: 0;
  min-width: 210px;
  font-size: 20px;
  line-height: 26px;
  .MatterSemiBold();
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border: 1px solid;
  &:hover {
    text-decoration: none;
  }
  .cta__text {
    padding: 0 20px;
  }
}

.cta-anchor {
  &.link,
  &.link-arrow,
  &.secondary,
  &.link-button,
  &.left-facing-link-button,
  &.left-facing-link-button-red {
    color: var(--cta-link-color, @ig-grey-900);
  }
}

.cta-anchor.primary,
.cta-anchor.secondary--dark,
.cta-anchor.link-button--dark {
  color: @white;
}

.cta-wrapper.primary {
  background-color: @cta-primary-color;
  border-color: @cta-primary-color;
  color: @white;
  &:hover {
    border-color: @cta-primary-hover-color;
    background-color: @cta-primary-hover-color;
  }
}

.cta-wrapper.secondary {
  color: var(--cta-link-color, @ig-grey-900);
  border-color: #2d2f2f;
  &:hover {
    background-color: @ig-grey-200;
  }
}

.cta-wrapper.link,
.link--dark,
.link-button,
.link-button--dark {
  display: table;
  margin-bottom: var(--cta-link-mb, @anchor-spacing);
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  .MatterMedium();
  color: #383534;

  .cta__text:not(:empty):after {
    content: '';
    width: 9px;
    height: 9px;
    margin: var(--cta-link-text-margin, 0 0 0 5px);
    display: inline-block;
    background-image: @cta-arrow-pointer;
    background-repeat: no-repeat;
    transform: var(--cta-link-transform, rotate(0deg));
  }
}

.cta-anchor.link-button,
.cta-anchor.link-button--dark {
  padding: 7px 10px;
  border: 1px solid #635f5d;
  &:hover {
    background-color: rgba(208, 208, 208, 0.5);
    text-decoration: none;
    color: inherit;
  }
}

.link-button--dark,
.cta-wrapper.secondary--dark {
  color: @white;
  border: 1px solid #d0d0d0;
  &:hover {
    color: @white;
  }
}

.cta-wrapper.secondary--dark:hover {
  background-color: rgba(208, 208, 208, 0.5);
}

.link:hover,
h3:hover {
  color: #c11516;
}

.link--dark,
.link--dark h3 {
  color: @white;
  &:hover {
    color: @ig-red;
  }
}

:host {
  .cta--right {
    margin-left: auto;
  }

  .cta--center {
    margin-left: auto;
    margin-right: auto;
  }
}

// Prime request a brochure
.cta-wrapper.tg-link .cta-anchor {
  color: @white;
  &:hover {
    color: #c11516;
  }
}

/* tablet breakpoint */
@media (max-width: @medium-breakpoint) {
  .cta-wrapper.primary,
  .cta-wrapper.secondary,
  .cta-wrapper.secondary--dark {
    width: 100%;
    max-width: 350px;
  }

  .link,
  .link-button {
    margin-bottom: calc(var(--cta-link-mb, @anchor-spacing) - 10px);
  }
}
